export const TorreDomains = ["@torre.co", "@torre.ai"];

export const isTorrexEmail = (email: string): boolean => TorreDomains.some(d => email.endsWith(d));

export const isTorrexTester = (email: string): boolean => {
  return /^(?!.*\+test$)(?!^\+test)(?=.*\+test).*@torre\.(co|ai)$/.test(email);
};
